
import state from './state'
// import { createLogger } from 'vuex'

import optionsGetters from './getters/optionsGetters'

import applicationMutations from './mutations/applicationMutations'
import applicationGetters from './getters/applicationGetters'
import applicationActions from './actions/applicationActions'

import objectsMutations from './mutations/objectsMutations'
import objectsGetters from './getters/objectsGetters'
import objectsActions from './actions/objectsActions'

import cartItemsMutations from './mutations/cartItemsMutations'
import cartItemsGetters from './getters/cartItemsGetters'

import catalogueMutations from './mutations/catalogueMutations'
import catalogueGetters from './getters/catalogueGetters'
import catalogActions from './actions/catalogActions'

import tendersGetters from './getters/tendersGetters'
import tenderMutations from './mutations/tenderMutations'
import tenderActions from './actions/tenderActions'

import authGetters from './getters/authGetters'
import authMutations from './mutations/authMutations'
import authActions from './actions/authActions'

import loggerActions from './actions/loggerActions'

import releasesGetters from './getters/releasesGetters'
import releasesAction from './actions/releasesAction'
import releasesMutations from './mutations/releasesMutations'

import stopListGetters from './getters/stopListGetters'
import stopListActions from './actions/stopListActions'
import stopListMutations from './mutations/stopListMutations'

import suppliersGetters from './getters/suppliersGetters'
import suppliersActions from './actions/suppliersActions'
import suppliersMutation from './mutations/suppliersMutation'


import additionalFieldsGetters from './getters/additionalFieldsGetters'
import additionalFieldsActions from './actions/additionalFieldsActions'
import additionalFieldsMutations from './mutations/additionalFieldsMutations'

import commonAction from './actions/commonAction'

// mutations
let mutations = Object.assign({}, 
  applicationMutations, objectsMutations, cartItemsMutations, catalogueMutations, tenderMutations,
  authMutations, releasesMutations, stopListMutations, suppliersMutation, additionalFieldsMutations)

// actions
let actions = Object.assign({}, 
  objectsActions, tenderActions, catalogActions, authActions, loggerActions, releasesAction,
  applicationActions, stopListActions, suppliersActions, commonAction, additionalFieldsActions)

// getters
let getters = Object.assign({}, 
  applicationGetters, objectsGetters, cartItemsGetters, tendersGetters, catalogueGetters, optionsGetters, 
  authGetters, releasesGetters, stopListGetters, suppliersGetters, additionalFieldsGetters)

let allState = Object.assign({}, state)

// const logger = createLogger({
//   collapsed: false, // auto-expand logged mutations
//   filter (mutation/*, stateBefore, stateAfter*/) {
//     // returns `true` if a mutation should be logged
//     // `mutation` is a `{ type, payload }`
//     return m`utation.type !== 'aBlocklistedMutation'
//   },
//   actionFilter (action/*, state*/) {
//     // same as `filter` but for actions
//     // `action` is a `{ type, payload }`
//     return action.type !== 'aBlocklistedAction'
//   },
//   transformer (state) {
//     // transform the state before logging it.
//     // for example return only a specific sub-tree
//     return state.subTree
//   },
//   mutationTransformer (mutation) {
//     // mutations are logged in the format of `{ type, payload }`
//     // we can format it any way we want.
//     return mutation.type
//   },
//   actionTransformer (action) {
//     // Same as mutationTransformer but for actions
//     return action.type
//   },
//   logActions: true, // Log Actions
//   logMutations: true, // Log mutations
//   logger: console, // implementation of the `console` API, default `console`
// })

export default {
  actions,
  getters,
  mutations,
  state: allState,
  // plugins: [logger]
}
